/**
 * UK HMRC matching: calendar-day offsets (not second-based windows).
 * Same-day = 0 days; 30-day (bed-and-breakfast) = 1–30 calendar days after disposal.
 */

export function dayStartTs(dayKey) {
  const ms = Date.parse(`${dayKey}T00:00:00.000Z`);
  return Number.isFinite(ms) ? Math.floor(ms / 1000) : 0;
}

export function utcDayKey(tsSec) {
  const ts = Number(tsSec || 0);
  if (!ts) return null;
  const d = new Date(ts * 1000);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function utcCalendarDayDiff(fromDayKey, toDayKey) {
  const from = dayStartTs(fromDayKey);
  const to = dayStartTs(toDayKey);
  if (!from || !to) return null;
  return Math.round((to - from) / 86400);
}

export function ukThirtyDayOffset(disposal = {}, lot = {}) {
  if (!disposal?.dayKey || !lot?.dayKey) return null;
  return utcCalendarDayDiff(disposal.dayKey, lot.dayKey);
}

export function isUkThirtyDayLot(disposal = {}, lot = {}) {
  const offset = ukThirtyDayOffset(disposal, lot);
  return offset != null && offset >= 1 && offset <= 30;
}

export function isUkThirtyDayCandidate(disposal = {}, acquisition = {}) {
  return isUkThirtyDayLot(disposal, acquisition);
}

/** Exclusive UTC ts: acquisitions through +30 calendar days after last tax-year day. */
export function ukThirtyDayLookAheadEndTs(taxYearEndTs) {
  if (!taxYearEndTs) return null;
  const lastDayKey = utcDayKey(taxYearEndTs - 1);
  if (!lastDayKey) return null;
  const lastDayStart = dayStartTs(lastDayKey);
  const d = new Date(lastDayStart * 1000);
  d.setUTCDate(d.getUTCDate() + 30);
  return Math.floor(d.getTime() / 1000) + 86400;
}
